function isValidDate(time: string): boolean {
  const date = new Date(time);
  return !isNaN(date.getTime());
}

function zuluToLocaleTimeConverter(time: string | undefined | null): string | undefined {
  if (time === undefined || time === null || !isValidDate(time)) {
    return 'No Date Available';
  }

  const timeZone = 'UTC';
  const localeTime = new Date(time).toLocaleString('en-US', {timeZone: timeZone});

  return `${localeTime} UTC`;
}

export default zuluToLocaleTimeConverter;
